import { render } from "./updateseating.vue?vue&type=template&id=fd890fa4"
import script from "./updateseating.vue?vue&type=script&lang=js"
export * from "./updateseating.vue?vue&type=script&lang=js"

import "./updateseating.vue?vue&type=style&index=0&id=fd890fa4&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__